// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import BoomUIBySkinId from '../../../constants/ui';
import type { BoomSkinId } from '../../../types/global';

const Wrapper = styled.div`
  position: relative;
  border-radius: 8px;
  padding: 0.3em 1em;
  font-size: 1em;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          opacity: 0.5;
        `
      : null}

  ${({ $isDark, $skinId }) => {
    const WrapperStyle = BoomUIBySkinId[$skinId]?.BETSLIP_BAND_STYLE[$isDark ? 'dark' : 'light'];

    return css`
      background-color: ${WrapperStyle?.backgroundColor};
      color: ${WrapperStyle?.color};
    `;
  }}

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          padding: 0.2em 0.3em;
          font-size: 0.8em;
        `
      : null}
`;

const DisabledReadyWrapper = styled.div`
  position: relative;

  display: inline-flex;
  align-items: center;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    transform-origin: center center;
    width: 100%;
    height: 0.15em;
    background: white;
    border-radius: 5em;
    opacity: 0;
    pointer-events: none;
  }

  ${({ $isDisabled }) =>
    $isDisabled
      ? css`
          &:after {
            opacity: 0.8;
          }
        `
      : null}

  ${({ $isFullWidth }) =>
    $isFullWidth
      ? css`
          display: flex;
          justify-content: center;
        `
      : null}

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          gap: 0.2em;
        `
      : undefined}
`;

const StyledPrimaryIcon = styled.img`
  height: 1.2em;
  margin-right: 0.3em;

  ${({ $isCompact }) =>
    $isCompact
      ? css`
          height: 1.2em;
          width: 1.2em;
        `
      : null}
`;

const Label = styled.div`
  font-weight: bold;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

type BoomBetslipBandProps = {
  className?: string;
  isDark: boolean;
  isCompact?: boolean;
  isFullWidth?: boolean;
  isDisabled?: boolean;
  label: string;
  icon?: string;
  skinId: BoomSkinId;
};

const BoomBetslipBand = ({
  className = '',
  isCompact = false,
  isDark = false,
  isFullWidth = false,
  isDisabled = false,
  label,
  icon,
  skinId,
}: BoomBetslipBandProps) => {
  return (
    <Wrapper className={className} $isCompact={isCompact} $isDark={isDark} $skinId={skinId} $isDisabled={isDisabled}>
      <DisabledReadyWrapper $isFullWidth={isFullWidth} $isDisabled={isDisabled} $isCompact={isCompact}>
        {icon ? <StyledPrimaryIcon src={icon} /> : null}
        <Label>{label}</Label>
      </DisabledReadyWrapper>
    </Wrapper>
  );
};

export default BoomBetslipBand;
